<template>
    <v-card class="pa-3">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <v-card-text
            v-if="!loading"
            class="px-0"
            v-bind:class="{
                'pt-0': !hasCurrentYear(),
            }"
        >
            <div
                v-if="hasCurrentYear()"
                class="px-0 pb-4"
                style="border: #5cb860 1px solid"
            >
                <v-layout
                    class="headline mb-4 px-2 py-2 font-weight-medium"
                    style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                    layout
                    row
                    justify-space-between
                    >Current Year: {{ getCurrentYear(regID) }}</v-layout
                >
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Previous Balance:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ previousBalance | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Billed:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ total | currency }}
                    </div>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    class="pb-2 px-4"
                    v-if="credit"
                >
                    <div class="heading font-weight-medium">
                        Credit:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ credit | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ paid | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Scheduled Payments:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ scheduledPayments | currency }}
                    </div>
                </v-layout>

                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Total Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ totalPaid | currency }}
                    </div>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    class="pb-2 px-4"
                    v-if="unprocessedPayments.length"
                >
                    <div class="heading font-weight-medium">
                        Unprocessed Payments:
                    </div>
                    <div class="heading font-weight-medium">
                        {{
                            getUnprocessedPaymentsTotalAmount(
                                unprocessedPayments,
                            ) | currency
                        }}
                    </div>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    class="px-4 mt-3 headline font-weight-bold"
                    style="color: #5cb860;"
                >
                    <div>
                        Total Balance:
                    </div>
                    <div>
                        {{ balance | currency }}
                    </div>
                </v-layout>

                <div v-if="accountType != 'billing'">
                    <v-divider class="mt-3 mb-3"></v-divider>
                    <v-layout row justify-space-between class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Lapidus Charges:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ account.totalLapidusCharges | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Lapidus Used:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ account.totalLapidusUsed | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Lapidus Available:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ account.totalLapidusAvailable | currency }}
                        </div>
                    </v-layout>
                </div>
            </div>

            <div
                v-if="getPastYearsEnrollmentInfo().length"
                class="px-0 "
                v-bind:class="{
                    'mt-5 pb-3': hasCurrentYear(),
                    'mt-0': !hasCurrentYear(),
                }"
                style="border: #5cb860 1px solid"
            >
                <v-layout
                    v-if="hasCurrentYear()"
                    class="headline mb-2 px-2 py-2 font-weight-medium"
                    style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                    layout
                    row
                    justify-space-between
                    >Other Years</v-layout
                >
                <div
                    v-for="(year, index) in getPastYearsEnrollmentInfo()"
                    class="pt-2 px-2"
                >
                    <router-link
                        class="year-link-text text-xs-center"
                        :to="getNavigationRoute(year)"
                        @click=""
                        >{{ getCurrentYear(year.regID) }}</router-link
                    >

                    <!-- <a
                        @click="navigateToOtherYear(year.regID)"
                        class="pb-2 text-xs-center year-link-text"
                        >{{ getCurrentYear(year.regID) }}</a
                    > -->
                    <v-layout row justify-space-between wrap class="pb-2 px-3">
                        <div class="heading font-weight-medium">
                            Previous Balance
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.lapidusAccount.previousBalance | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between wrap class="pb-2 px-3">
                        <div class="heading font-weight-medium">
                            Billed
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.lapidusAccount.debit | currency }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        justify-space-between
                        wrap
                        class="pb-2 px-3"
                        v-if="year.lapidusAccount.credit"
                    >
                        <div class="heading font-weight-medium">
                            Credit
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.lapidusAccount.credit | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between wrap class="pb-2 px-3">
                        <div class="heading font-weight-medium">
                            Total Paid
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.lapidusAccount.totalPaid | currency }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        justify-space-between
                        wrap
                        class="pb-2 px-3 title font-weight-bold"
                        style="color: #5cb860;"
                    >
                        <div>
                            Total Balance
                        </div>
                        <div>
                            {{ year.lapidusAccount.balance | currency }}
                        </div>
                    </v-layout>
                    <table
                        id="enrollments"
                        class="mt-2"
                        v-if="accountType != 'billing'"
                    >
                        <tr>
                            <th>Name</th>
                            <th>Reg Type</th>
                            <th>Amount</th>
                        </tr>
                        <tr v-for="enrollment in year.enrollments">
                            <td>{{ enrollment.name }}</td>
                            <td>{{ enrollment.regType }}</td>
                            <td>{{ enrollment.amount | currency }}</td>
                        </tr>
                    </table>

                    <v-divider
                        class="mt-3 pb-2"
                        v-if="index + 1 < getPastYearsEnrollmentInfo().length"
                        :key="index"
                    ></v-divider>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import { sum } from "../../utils/helpers.js";

export default {
    props: {
        regID: { type: String },
        loading: { type: Boolean },
        total: { type: Number },
        previousBalance: { type: Number },
        paid: { type: Number },
        credit: { type: Number },
        balance: { type: Number },
        totalPaid: { type: Number },
        scheduledPayments: { type: Number },
        pastYearsEnrollmentInfo: Array,
        unprocessedPayments: Array,
        account: Object,
        accountType: String,
        voucherAccount: Object,
        reload: Function,
    },
    data: () => ({
        terms: [],
    }),
    watch: {
        $route(to, from) {
            this.reload();
        },
    },
    async created() {
        await this.loadRegTerms();
    },
    methods: {
        getCurrentYear(regID) {
            if (!regID) return;

            return regID.substring(2);
        },
        getPastYearsEnrollmentInfo() {
            return this.pastYearsEnrollmentInfo.filter(
                (e) => e.regID != this.regID,
            );
        },
        hasCurrentYear() {
            return this.pastYearsEnrollmentInfo.some(
                (e) => e.regID == this.regID,
            );
        },
        getUnprocessedPaymentsTotalAmount(unprocessedPayments) {
            return sum(unprocessedPayments.map((u) => u.amount));
        },
        async loadRegTerms() {
            const terms = await this.$http.get(
                "api/lapidusDayCamp/getRegTerms",
            );

            this.terms = terms;
        },
        getNavigationRoute(year) {
            const route = {
                name:
                    this.accountType == "billing"
                        ? "LapidusBillingView"
                        : "LapidusAccountView",
                params: {
                    id: year.lapidusAccount.accountID,
                    reg_id: year.regID,
                },
            };

            return route;
        },
        // navigateToOtherYear(regID) {
        //     const route = {
        //         name:
        //             this.accountType == "billing"
        //                 ? "LapidusBillingView"
        //                 : "LapidusAccountView",
        //         params: { id: this.account.accountID, reg_id: regID },
        //     };

        //     if (this.$route.query.isGirls) {
        //         route.query = {
        //             isGirls: true,
        //         };
        //     }

        //     this.$router.push(route);
        // },
    },
};
</script>
<style>
.year-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
    font-size: 20px;
}
#enrollments {
    border-collapse: collapse;
    width: 100%;
}

#enrollments td,
#enrollments th {
    border: 1px solid #ddd;
    padding: 8px;
}

#enrollments tr:nth-child(odd) {
    background-color: #f2f2f2;
}

#enrollments tr:hover {
    background-color: #ddd;
}

#enrollments th {
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: left;
    background-color: #4caf50;
    color: white;
}
</style>
